import _Icon from "@alifd/next/lib/icon";
import _extends from "@babel/runtime/helpers/extends";
import { isValidElement, createElement, cloneElement } from 'react';
import { isReactComponent } from './is-react';
import { isESModule } from './is-es-module';
var URL_RE = /^(https?:)\/\//i;
export function createIcon(icon, props) {
  if (!icon) {
    return null;
  }
  if (isESModule(icon)) {
    icon = icon["default"];
  }
  if (typeof icon === 'string') {
    if (URL_RE.test(icon)) {
      return /*#__PURE__*/createElement('img', _extends({
        src: icon,
        "class": props === null || props === void 0 ? void 0 : props.className
      }, props));
    }
    return /*#__PURE__*/React.createElement(_Icon, _extends({
      type: icon
    }, props));
  }
  if ( /*#__PURE__*/isValidElement(icon)) {
    return /*#__PURE__*/cloneElement(icon, _extends({}, props));
  }
  if (isReactComponent(icon)) {
    return /*#__PURE__*/createElement(icon, _extends({
      "class": props === null || props === void 0 ? void 0 : props.className
    }, props));
  }
  return /*#__PURE__*/React.createElement(_Icon, _extends({}, icon, props));
}